var map = {
	"./3dcapsule.png": 72,
	"./3dtriangle.png": 71,
	"./3dtube.png": 103,
	"./Arrow Right.svg": 66,
	"./Design.svg": 104,
	"./Design2.svg": 69,
	"./Develop.svg": 105,
	"./Support.svg": 106,
	"./Website Image-1.png": 107,
	"./Website Image-2.png": 108,
	"./Website Image-3.png": 109,
	"./_Design.svg": 110,
	"./_Develope.svg": 111,
	"./_Support.svg": 112,
	"./_avatar-1.jpg": 73,
	"./_avatar-2.jpg": 74,
	"./_avatar-3.jpg": 75,
	"./_avatar-4.jpg": 76,
	"./arrow-up.svg": 55,
	"./avatar-1.jpg": 77,
	"./avatar-2.jpg": 78,
	"./avatar-3.jpg": 79,
	"./avatar-4.jpg": 80,
	"./beyondbooksorg.png": 56,
	"./beyondbooksorg1.png": 113,
	"./blob purple.svg": 49,
	"./blob white.svg": 50,
	"./blobPink.svg": 48,
	"./bootstrap.png": 38,
	"./css3.png": 37,
	"./digital.svg": 114,
	"./django.png": 44,
	"./dmtechtree.png": 57,
	"./dmtechtree1.png": 115,
	"./envelope-open-solid.svg": 23,
	"./facebook-square-brands.svg": 24,
	"./gears.svg": 70,
	"./hand.svg": 68,
	"./hombre.svg": 67,
	"./html5.png": 36,
	"./human.svg": 116,
	"./instagram-square-brands.svg": 25,
	"./java.png": 41,
	"./javascript.png": 39,
	"./jquery.png": 40,
	"./linkedin-brands.svg": 26,
	"./logo.svg": 81,
	"./maeoil.png": 58,
	"./maeoil2.png": 117,
	"./mobile.svg": 118,
	"./mysql.png": 46,
	"./nammadoors.png": 59,
	"./nammadoors2.png": 119,
	"./online.svg": 120,
	"./ourwork.svg": 60,
	"./postgresql.png": 47,
	"./programming.svg": 53,
	"./python.png": 43,
	"./reactimg.png": 45,
	"./rocket image.png": 121,
	"./spring.png": 42,
	"./support2.svg": 54,
	"./taxactindia.png": 61,
	"./taxactindia1.png": 122,
	"./taxactindia3.png": 123,
	"./twitter-square-brands.svg": 27,
	"./wave.svg": 124,
	"./wave_blue.svg": 125,
	"./wave_gray.svg": 52,
	"./wave_yellow.svg": 126,
	"./waves.svg": 127,
	"./working.svg": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;